import React, { useEffect, useRef } from 'react';

const VideoParticipant = ({ participant, isLocal }) => {
  const videoRef = useRef();
  const audioRef = useRef();

  useEffect(() => {
    if (!participant) return;

    // Attach video tracks
    const videoTrack = Array.from(participant.videoTracks.values())[0];
    if (videoTrack && videoTrack.track) {
      const videoElement = videoTrack.track.attach();
      if (videoRef.current) {
        videoRef.current.innerHTML = '';
        videoRef.current.appendChild(videoElement);
      }
    }

    // Attach audio tracks (not for local participant to avoid echo)
    if (!isLocal) {
      const audioTrack = Array.from(participant.audioTracks.values())[0];
      if (audioTrack && audioTrack.track) {
        const audioElement = audioTrack.track.attach();
        if (audioRef.current) {
          audioRef.current.innerHTML = '';
          audioRef.current.appendChild(audioElement);
        }
      }
    }

    // Listen for track subscriptions (for remote participants)
    if (!isLocal) {
      const handleTrackSubscribed = (track) => {
        if (track.kind === 'video' && videoRef.current) {
          videoRef.current.innerHTML = '';
          videoRef.current.appendChild(track.attach());
        } else if (track.kind === 'audio' && audioRef.current) {
          audioRef.current.innerHTML = '';
          audioRef.current.appendChild(track.attach());
        }
      };

      const handleTrackUnsubscribed = (track) => {
        track.detach().forEach(element => element.remove());
      };

      participant.on('trackSubscribed', handleTrackSubscribed);
      participant.on('trackUnsubscribed', handleTrackUnsubscribed);

      return () => {
        participant.off('trackSubscribed', handleTrackSubscribed);
        participant.off('trackUnsubscribed', handleTrackUnsubscribed);
      };
    }
  }, [participant, isLocal]);

  return (
    <div className={`participant ${isLocal ? 'local' : 'remote'}`}>
      <div ref={videoRef} className="video-track" />
      <div ref={audioRef} className="audio-track" style={{ display: 'none' }} />
      <div className="participant-identity">
        {participant?.identity} {isLocal ? '(You)' : ''}
      </div>
    </div>
  );
};

export default VideoParticipant;
